import { Markdown } from "@/components/chat/Markdown";
import { cn } from "@/lib/utils";

const TAGS = { interrupted: "Interrupted", stopped: "Stopped speaking", partial: "Reply cut short" };

export function VoiceTranscript({ turns }) {
  if (!turns.length) return null;
  return (
    <section className="space-y-4" aria-live="polite" data-testid="voice-transcript">
      {turns.map((t, i) =>
        t.role === "user" ? (
          <div key={t.id} className="ml-auto max-w-[85%] rounded-2xl bg-[#1e1e24] px-4 py-2.5 text-[15px] text-white" data-testid={`voice-turn-user-${i}`}>
            {t.text}
          </div>
        ) : (
          <div key={t.id} className="max-w-[92%]" data-testid={`voice-turn-assistant-${i}`}>
            <div className="mb-1 text-[11px] uppercase tracking-[0.16em] text-zinc-500">JARVIS</div>
            <div className={cn("cs-prose text-[15px] leading-relaxed text-zinc-200", !t.text && "text-zinc-500")}>
              {t.text ? <Markdown content={t.text} /> : t.status === "streaming" ? "…" : ""}
            </div>
            {TAGS[t.status] && <span className="mt-1 inline-block text-xs text-zinc-500" data-testid={`voice-turn-tag-${i}`}>{TAGS[t.status]}</span>}
          </div>
        ),
      )}
    </section>
  );
}
